// extracted by mini-css-extract-plugin
export default {"kontener":"TrescWydruku_kontener__Lo+av","przycisk":"TrescWydruku_przycisk__mOp9p","ha3":"TrescWydruku_ha3__C0e0N"};